import {app} from '../../app';
import {SharedQuestionService} from "../../services/SharedQuestionService";
import IScope = angular.IScope;
import {PageSharedQuestion} from "../../sharedQuestions/PageSharedQuestion";

export class PageQuestionComponent implements ng.IComponentController {

    private sharedQuestionService:SharedQuestionService;
    private sharedQuestion:PageSharedQuestion;

    question:IQuestion;
    questions:IQuestion[];
    questionsComponents:string = '';

    preventNextQuestion = true;
    previousQuestionCallback:() => void;
    nextQuestionCallback:() => void;
    showSessionPagination:boolean;
    hasPreviousQuestion:boolean;

    static $inject = ['SharedQuestionService'];

    constructor(sharedQuestionService:SharedQuestionService) {
        this.sharedQuestionService = sharedQuestionService;
    }

    $onInit() {
        this.sharedQuestion          = new PageSharedQuestion();
        this.sharedQuestion.question = this.question;
        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        if (this.question.questions != null && this.question.questions.length > 0) {
            this.questions = SharedQuestionService.sortQuestions(this.question.questions);
            this.questions = this.question.questions;
            this.questions.forEach((question, index) => {
                let questionControl = '';

                // questionControl += index === this.questions.length - 1 ?
                //     'next-question-callback="pageQuestion.nextQuestionCallback()" ' :
                //     'prevent-next-question="true" ';
                questionControl += 'next-question-callback="pageQuestion.nextQuestionCallback()" ';

                questionControl += index === 0 ?
                    'previous-question-callback="pageQuestion.previousQuestionCallback()" ' :
                    'prevent-previous-question="true" ';

                this.questionsComponents += '<' + question.type + '-question question="pageQuestion.questions[' + index + ']" ' +
                    'question-id="' + question.id + '" ' +
                    'show-session-pagination="pageQuestion.showSessionPagination"' +
                    'has-previous-question="session.hasPreviousQuestion"' +
                    questionControl +
                    '></' + question.type + '-question>';
            });
        }
    }

}

app.component('pageQuestion', {
    templateUrl : 'templates/components/questionTypes/pageQuestion.html',
    controller  : PageQuestionComponent,
    controllerAs: 'pageQuestion',
    bindings    : {
        question                : '<',
        previousQuestionCallback: '&',
        nextQuestionCallback    : '&',
        showSessionPagination   : '=',
        hasPreviousQuestion     : '='
    }
});